import React, { useState } from 'react';
import './GalleryItem.css';

const GalleryItem = ({ gallery }) => {
  const { image } = gallery;

  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  const openLightbox = () => {
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  return (
    <div>
      <img
        className="clickable-image"
        src={image}
        alt=""
        onClick={openLightbox}
      />
      {isLightboxOpen && (
        <div className="lightbox" onClick={closeLightbox}>
          <img className="lightbox-image" src={image} alt="" />
        </div>
      )}
    </div>
  );
};

export default GalleryItem;
